import React from 'react';
import PropTypes from 'prop-types';
import Title from '../title/Title';
import EmptyCart from '../empty_cart/EmptyCart';
import CartContent from '../cart_content/CartContent';
import styles from './CartContainer.module.sass';

const CartContainer = React.forwardRef((props, ref) => {
  const {
    lineItems, lineItemsCount, orderNumber,
    guestToken, closeCart, applyCouponCodeRequest,
    orderTotal, couponCodeErrorText, couponCodeSuccessText, orderLoading,
  } = props;

  return (
    <div ref={ref} className={styles['cart-container']}>
      <Title
        closeCart={closeCart}
        lineItemsCount={lineItemsCount}
      />
      { lineItemsCount === 0 && <EmptyCart /> }
      { lineItemsCount > 0 && (
        <CartContent
          applyCouponCodeRequest={applyCouponCodeRequest}
          couponCodeErrorText={couponCodeErrorText}
          couponCodeSuccessText={couponCodeSuccessText}
          guestToken={guestToken}
          lineItems={lineItems}
          orderLoading={orderLoading}
          orderNumber={orderNumber}
          orderTotal={orderTotal}
        />
      ) }
    </div>
  );
});

CartContainer.propTypes = {
  applyCouponCodeRequest: PropTypes.func.isRequired,
  closeCart: PropTypes.func.isRequired,
  couponCodeErrorText: PropTypes.string,
  couponCodeSuccessText: PropTypes.string,
  guestToken: PropTypes.string,
  lineItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  lineItemsCount: PropTypes.number.isRequired,
  orderLoading: PropTypes.bool,
  orderNumber: PropTypes.string,
  orderTotal: PropTypes.number.isRequired,
};

CartContainer.defaultProps = {
  couponCodeErrorText: null,
  couponCodeSuccessText: null,
  guestToken: null,
  orderLoading: false,
  orderNumber: null,
};

export default CartContainer;
